module.exports = __webpack_public_path__ + "user_reviews.b93792bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/user_reviews.png
// module id = 222
// module chunks = 0